import React, { useRef } from "react";
import { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";

import upIcon from "../assets/images/up.png";
import downIcon from "../assets/images/down.png";
import constants from "../assets/js/constants";
import { getVisibleSensorAnimation } from "../assets/js/utils";
import useCounterAnimation from "./hooks/useCounterAnimation";
import HorizontalBar from "./HorizontalBar";

function InfoBarDescriptor({ title, unit, value, barValues = [], flipIcon }) {
  const [isVisible, setIsVisible] = useState(false);
  const counterRef = useRef();
  useCounterAnimation(counterRef, value, isVisible, "animate two");

  const handleVisibility = (visible) => {
    setIsVisible(visible);
  };
  return (
    <VisibilitySensor partialVisibility onChange={handleVisibility}>
      <article
        className="info-bar-descriptor"
        style={getVisibleSensorAnimation(isVisible, "fadeIn 1s backwards")}
      >
        <header className="info-bar-descriptor__header">
          <span className="info-bar-descriptor__heading">{title}</span>
        </header>
        <div className="info-bar-descriptor__body">
          <div
            className="info-bar-descriptor__value-container"
            style={getVisibleSensorAnimation(isVisible, "fade-in-20 1s")}
          >
            <span className="info-bar-descriptor__unity">{unit}</span>
            <span ref={counterRef} className="info-bar-descriptor__value">
              {}
            </span>
          </div>
          <span className="empty-cell"></span>
          <img
            src={flipIcon ? downIcon : upIcon}
            alt=""
            className="info-bar-descriptor__up-icon"
            style={getVisibleSensorAnimation(
              isVisible,
              `${
                flipIcon
                  ? "info-bar-descriptor__up-icon-animation-flipped"
                  : "info-bar-descriptor__up-icon-animation"
              } 1.5s 1s backwards`
            )}
          />
        </div>
        <div className="info-bar-descriptor__bar">
          <HorizontalBar value={barValues[0]} position={1} />
          <HorizontalBar
            color={constants.COLORS.DARK}
            backgroundColor={constants.COLORS.SECONDARY}
            widthPercentage="80%"
            value={barValues[1]}
            position={2}
          />
        </div>
      </article>
    </VisibilitySensor>
  );
}

export default InfoBarDescriptor;
